import { Chart, Grid, RectangleStackIcon } from 'components'
import { isEmpty } from 'lodash-es'
import { DCFilter } from 'types'
import { useBreakpoint } from 'utils'
import { StatTile } from '..'
import { useEvent, useOnTheGo } from '../../utils'
import { Aggregation, limitAggregationData, useAggregations } from '../../utils/analyticsUtils'

export default function AnalyticsUserTraitsSection() {
  const isMobile = useBreakpoint() < 2
  const { event, filters: eventFilters = [], setFilters: setEventFilters } = useEvent()
  const { filters: onTheGoFilters = [], setFilters: setOnTheGoFilters } = useOnTheGo()
  const filters = event ? eventFilters : onTheGoFilters
  const setFilters = event ? setEventFilters : setOnTheGoFilters
  const { aggregations } = useAggregations([
    {
      table: 'sessionTraits',
      values: ['_count'],
      categories: ['groupTitle', 'title'],
      sort: { _count: 'DESC' },
      filters: filters,
    },
  ])

  const dataByGroup = aggregations[0]?.data?.reduce(
    (acc, cur) => {
      const group = cur.groupTitle || 'Other'
      if (!acc[group]) acc[group] = { ...aggregations[0], categories: ['title'], data: [] }
      acc[group].data!.push(cur)
      return acc
    },
    {} as Record<string, Aggregation>
  )

  function handleSelect(traitTitle: string, traitValue: string) {
    const selectedFilters: DCFilter = {
      field: 'title',
      operator: 'ILIKE',
      value: traitValue,
      table: 'sessionTraits',
      secondaryTargetField: 'groupTitle',
      secondaryTargetValue: traitTitle,
    }

    setFilters([...filters, selectedFilters])
  }

  if (isEmpty(dataByGroup)) return null

  return (
    <Grid templateColumns={`repeat(auto-fill, minmax(350px, 1fr))`} gap={6}>
      {Object.entries(dataByGroup).map(
        ([group, aggregation]) =>
          !!aggregation.data?.length && (
            <StatTile
              h="345px"
              key={group}
              alignItems="stretch"
              label={group}
              Icon={RectangleStackIcon}
              canCopy
            >
              <Chart
                {...aggregation}
                data={limitAggregationData(aggregation)}
                onSelect={isMobile ? undefined : ({ label }) => handleSelect(group, label)}
              />
            </StatTile>
          )
      )}
    </Grid>
  )
}
